/**
 * Collection Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Collection template.
 *
 * @namespace collection
 */

import {register} from '@shopify/theme-sections';

register('collection-template', {
  onLoad() {
    /**
     * Sort by
     */
    $("#sort-by option").each(function(index, option) {
      const urlSearchParams = new URLSearchParams(window.location.search);
      if (urlSearchParams.toString().includes(option.value)) {
        option.setAttribute('selected','selected');
      }
    });
    
    document.querySelector('#sort-by').addEventListener('change', function() {
      const urlSearchParams = new URLSearchParams(window.location.search);
      urlSearchParams.set('sort_by', this.value);
      window.location = `?${urlSearchParams.toString()}`;
    });

    /**
     * Filter toggles
     */
    const $filterToggles = this.container.querySelectorAll('[data-toggle-filters]');
    $filterToggles.forEach($filterToggle => {
      $filterToggle.addEventListener('click', handleToggleFilters);
    });

    const $filterTogglesOverlay = this.container.querySelectorAll('.background-overlay-filter-menu');
    $filterTogglesOverlay.forEach($filterTogglesOverlay => {
      $filterTogglesOverlay.addEventListener('click', handleToggleFilters);
    });

    function handleToggleFilters(e) {
      document.body.classList.toggle('filters-are-visible');
    }
  },
});
